import * as Cookies from 'js-cookie';

const MOBILE_COOKIE_NAME = 'isMobileApp';

export const isMobileApp = () => Cookies.get(MOBILE_COOKIE_NAME) === '1';
